'use strict';

Object.defineProperty(exports, "__esModule", {
	value: true
});

var _createClass = function () { function defineProperties(target, props) { for (var i = 0; i < props.length; i++) { var descriptor = props[i]; descriptor.enumerable = descriptor.enumerable || false; descriptor.configurable = true; if ("value" in descriptor) descriptor.writable = true; Object.defineProperty(target, descriptor.key, descriptor); } } return function (Constructor, protoProps, staticProps) { if (protoProps) defineProperties(Constructor.prototype, protoProps); if (staticProps) defineProperties(Constructor, staticProps); return Constructor; }; }();

var _react = require('react');

var _react2 = _interopRequireDefault(_react);

var _classnames = require('classnames');

var _classnames2 = _interopRequireDefault(_classnames);

function _interopRequireDefault(obj) { return obj && obj.__esModule ? obj : { default: obj }; }

function _classCallCheck(instance, Constructor) { if (!(instance instanceof Constructor)) { throw new TypeError("Cannot call a class as a function"); } }

function _possibleConstructorReturn(self, call) { if (!self) { throw new ReferenceError("this hasn't been initialised - super() hasn't been called"); } return call && (typeof call === "object" || typeof call === "function") ? call : self; }

function _inherits(subClass, superClass) { if (typeof superClass !== "function" && superClass !== null) { throw new TypeError("Super expression must either be null or a function, not " + typeof superClass); } subClass.prototype = Object.create(superClass && superClass.prototype, { constructor: { value: subClass, enumerable: false, writable: true, configurable: true } }); if (superClass) Object.setPrototypeOf ? Object.setPrototypeOf(subClass, superClass) : subClass.__proto__ = superClass; }

var CHART_TYPES = [{
	slug: 'table',
	label: 'Table',
	icon: 'ri-table'
}, {
	slug: 'line',
	label: 'Line',
	icon: 'ri-line-chart'
}, {
	slug: 'bar',
	label: 'Bar',
	icon: 'ri-bar-chart'
}, {
	slug: 'pie',
	label: 'Pie',
	icon: 'ri-pie-chart'
},
// {
// 	slug: 'bubble',
// 	label: 'Bubble',
// 	icon: 'ri-bubble-chart'
// },
{
	slug: 'key-figure',
	label: 'Key Figure',
	icon: 'ri-key-figures'
}];

var ChartTypeSelector = function (_React$Component) {
	_inherits(ChartTypeSelector, _React$Component);

	function ChartTypeSelector() {
		_classCallCheck(this, ChartTypeSelector);

		return _possibleConstructorReturn(this, (ChartTypeSelector.__proto__ || Object.getPrototypeOf(ChartTypeSelector)).apply(this, arguments));
	}

	_createClass(ChartTypeSelector, [{
		key: 'render',
		value: function render() {
			return _react2.default.createElement(
				'div',
				{ className: 'input-wrapper' },
				_react2.default.createElement(
					'label',
					null,
					'Create a: '
				),
				_react2.default.createElement(
					'div',
					{ className: 'chart-type-selector' },
					CHART_TYPES.map(this.renderItem.bind(this))
				)
			);
		}
	}, {
		key: 'renderItem',
		value: function renderItem(item) {
			var selected = this.props.selected;

			return _react2.default.createElement(
				'div',
				{
					key: item.slug,
					className: (0, _classnames2.default)("chart-type", { selected: item.slug == selected }),
					onClick: this.selectItem.bind(this, item.slug)
				},
				_react2.default.createElement(
					'div',
					{ className: 'icon' },
					_react2.default.createElement('i', { className: item.icon }),
					_react2.default.createElement(
						'div',
						{ className: 'ct-label' },
						item.label
					)
				)
			);
		}
	}, {
		key: 'selectItem',
		value: function selectItem(slug) {
			this.props.onChange(slug);
		}
	}]);

	return ChartTypeSelector;
}(_react2.default.Component);

exports.default = ChartTypeSelector;


//////////////////
// WEBPACK FOOTER
// ./resources/assets/js/components/maker/ChartTypeSelector.js
// module id = 573
// module chunks = 0